
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'; 
import './PersonForm.scss';

const PersonForm = ({ onAddPerson, persons }) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    name: '',
    personId: '',
    assignedTo: '',
    type: 'Member',
    isNewName: true,
    isNewId: true
  });
  const [showNameInput, setShowNameInput] = useState(false);
  const [showIdInput, setShowIdInput] = useState(false);

  const existingNames = [...new Set((persons || []).map(p => p.name))];
  const existingIds = [...new Set((persons || []).map(p => p.personId))];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.personId || !formData.assignedTo) {
      alert('Please fill in all required fields');
      return;
    }

    onAddPerson(formData);
    setFormData({
      name: '',
      personId: '',
      assignedTo: '',
      type: 'Member',
      isNewName: true,
      isNewId: true
    });
    history.push('/'); 
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="person-form-container">
      <div className="form-card">
        <h2>Adaugă membru nou</h2>
        <form onSubmit={handleSubmit} className="person-form">
          
          {/* Person Name Section */}
          <div className="form-group">
            <label>Nume Membru</label>
            <div className="input-options">
              <button 
                type="button"
                className={`option-btn ${formData.isNewName ? 'active' : ''}`}
                onClick={() => {
                  setFormData(prev => ({ ...prev, isNewName: true, name: '' }));
                  setShowNameInput(true);
                }}
              >
                Membru nou
              </button>
              <button 
                type="button"
                className={`option-btn ${!formData.isNewName ? 'active' : ''}`}
                onClick={() => {
                  setFormData(prev => ({ ...prev, isNewName: false }));
                  setShowNameInput(false);
                }}
              >
                Selectează din listă
              </button>
            </div>
            
            {formData.isNewName || showNameInput ? (
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                placeholder="Introduceți numele membrului"
                required
              />
            ) : (
              <select
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                required
              >
                <option value="">Selectează un nume</option>
                {existingNames.map(name => (
                  <option key={name} value={name}>{name}</option>
                ))}
              </select>
            )}
          </div>

          {/* Person ID Section */}
          <div className="form-group">
            <label>ID Membru</label>
            <div className="input-options">
              <button 
                type="button"
                className={`option-btn ${formData.isNewId ? 'active' : ''}`}
                onClick={() => {
                  setFormData(prev => ({ ...prev, isNewId: true, personId: '' }));
                  setShowIdInput(true);
                }}
              >
                ID Nou
              </button>
              <button 
                type="button"
                className={`option-btn ${!formData.isNewId ? 'active' : ''}`}
                onClick={() => {
                  setFormData(prev => ({ ...prev, isNewId: false }));
                  setShowIdInput(false);
                }}
              >
                Selectează din listă
              </button>
            </div>
            
            {formData.isNewId || showIdInput ? (
              <input
                type="text"
                value={formData.personId}
                onChange={(e) => handleInputChange('personId', e.target.value)}
                placeholder="Introduceți ID-ul membrului"
                required
              />
            ) : (
              <select
                value={formData.personId}
                onChange={(e) => handleInputChange('personId', e.target.value)}
                required
              >
                <option value="">Selectează un ID</option>
                {existingIds.map(id => (
                  <option key={id} value={id}>{id}</option>
                ))}
              </select>
            )}
          </div>

          {/* Assigned To */}
          <div className="form-group">
            <label>Asignare Consultant</label>
            <input
              type="text"
              value={formData.assignedTo}
              onChange={(e) => handleInputChange('assignedTo', e.target.value)}
              placeholder="Introduceți numele consultantului"
              required
            />
          </div>

          {/* Type Selection */}
          <div className="form-group">
            <label>Tipul</label>
            <div className="type-selection">
              <button
                type="button"
                className={`type-btn ${formData.type === 'Member' ? 'active member' : ''}`}
                onClick={() => handleInputChange('type', 'Member')}
              >
                Membru
              </button>
              <button
                type="button"
                className={`type-btn ${formData.type === 'Consultant' ? 'active consultant' : ''}`}
                onClick={() => handleInputChange('type', 'Consultant')}
              >
                Consultant
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-btn">Adaugă</button>
            <button 
              type="button" 
              className="cancel-btn"
              onClick={() => history.push('/')}
            >
              Anulare
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PersonForm;
